import React, { Component } from 'react';
import DUISnackbar from '@tencent/dui/lib/components/Snackbar';
import Divider from '@tencent/dui/lib/components/Divider';
import Modal from '@tencent/dui/lib/components/Modal';
import classNames from 'classnames';
import styles from '../index.css';
import { getInsertTableMenuData } from '../../../../editor/src/js/constants/toolbar-data';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { PlaceHolderMode } from '../../../../../slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import { canvasToEmu } from '../../../../../slide/infrastructure/module/independent/unit';
import Elements from '@src/slide/domain/ui-model/elements/default';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import NumberInput from '../../property-editor/editor-components/number-input';
import Provider from '../../provider';
import {
    EventCodeType,
    TDWActionType,
    TDWModuleType,
    TDWOperationType, TDWVer10Type, TDWVer4Type,
} from '../../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import i18n from '@i18next/i18n';

import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import {
    defaultTableWidth,
    minColWidth,
    minRowHeight,
    TableDefault,
    defaultSlideWidth,
} from '@src/slide/domain/ui-model/element-modeles/config/default-data/table-default';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';
import { ITableData } from '@tencent/slide-sdk-model';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { InjectorService, ToolbarService } from '@tencent/workbench';

interface CreateTableDialogProps {
    rowCount: number;
    colCount: number;
    onRowColCountChange?: (rowCount: number, colCount: number) => void;
}

interface CreateTableDialogState {
    rowCount: number;
    colCount: number;
}

class CreateTableDialog extends Component<CreateTableDialogProps, CreateTableDialogState> {
    public constructor(props: CreateTableDialogProps) {
        super(props);
        this.state = {
            rowCount: props.rowCount,
            colCount: props.colCount,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps) {
        this.setState({
            rowCount: nextProps.rowCount,
            colCount: nextProps.colCount,
        });
    }

    public render() {
        return (
            <Provider>
                <React.Fragment>
                    <div style={{ display: 'inline-block' }}>
                        <span style={{ marginRight: '12px' }}>{i18n.t('行数')}</span>
                        <NumberInput style={{ display: 'inline-block', width: '100px' }} onValueChange={this.handleCustomRowCountChange}
                            value={this.state.rowCount} step={1} maxLength={3} min={1} max={999}/>
                        <span style={{
                            position: 'absolute', marginLeft: '40px', marginTop: '5px', display: 'block', fontSize: '12px', color: 'red',
                            maxWidth: '120px',
                        }}>
                            {this.state.rowCount > 20 || this.state.rowCount < 1 ? i18n.t('有效数值为1至20') : ''}
                        </span>
                    </div>
                    <div style={{ display: 'inline-block', position: 'absolute', right: '24px' }}>
                        <span style={{ marginRight: '12px' }}>{i18n.t('列数')}</span>
                        <NumberInput style={{ display: 'inline-block', width: '100px' }} onValueChange={this.handleCustomColCountChange}
                            value={this.state.colCount} step={1} maxLength={3} min={1} max={999}/>
                        <span style={{
                            position: 'absolute', marginLeft: '40px', marginTop: '5px', display: 'block', fontSize: '12px', color: 'red',
                            maxWidth: '120px',
                        }}>
                            {this.state.colCount > 20 || this.state.colCount < 1 ? i18n.t('有效数值为1至20') : ''}
                        </span>
                    </div>
                </React.Fragment>
            </Provider>
        );
    }

    private getValidValue = (value: string): number => (value && value.length > 0 ? parseInt(value, 10) : 0);

    private handleCustomRowCountChange = (value: string): void => {
        const validValue = this.getValidValue(value);
        this.setState({
            rowCount: validValue,
        });
        this.props.onRowColCountChange?.(validValue, this.state.colCount);
    };

    private handleCustomColCountChange = (value: string): void => {
        const validValue = this.getValidValue(value);
        this.setState({
            colCount: validValue,
        });
        this.props.onRowColCountChange?.(this.state.rowCount, validValue);
    };
}

interface TableMenuProps {
    style?: React.CSSProperties;
    hideMenu?: () => void;
    fromMenu?: boolean;
    wbPath?: string[];
}

interface TableMenuState {
    selectedIndex: number
}

type IDeleteElement = ITableModel | IShapeModel | IPictureModel;
export default class TableMenu extends Component<TableMenuProps, TableMenuState> {
    private customRowCount: number;
    private customColCount: number;
    public constructor(props: TableMenuProps) {
        super(props);

        this.state = {
            selectedIndex: -1,
        };

        this.customRowCount = 2;
        this.customColCount = 5;
    }

    public render(): JSX.Element {
        const datas = getInsertTableMenuData();
        const rowCount = Math.floor(this.state.selectedIndex / 10.0) + 1;
        const colCount = (this.state.selectedIndex % 10) + 1;
        const title = this.state.selectedIndex < 0 ? i18n.t('插入表格') : i18n.t('{0}x{1}表格', { 0: colCount, 1: rowCount });
        return (
            <div className={styles.insertTableMenuContainer} style={this.props.style}>
                <div className={styles.insertTableMenuTitle}>{title}</div>
                <div className={styles.insertTableContainer}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={this.handleClick}>
                    {datas?.map((itemData: any, i: number) => {
                        const itemStyle = { height: '12px', width: '12px', padding: '0px' };
                        const itemClass = classNames({
                            [styles.insertTableMenuItem]: true,
                            [styles.insertTableMenuItemSelected]: i % 10 <= this.state.selectedIndex % 10
                                && i / 10 <= this.state.selectedIndex / 10,
                        });
                        return (
                            <div key={i} style={itemStyle} className={itemClass} onMouseOver={this.handleMouseOver(i)}>

                            </div>
                        );
                    })}
                </div>
                <Divider />
                <div className={styles.insertTableMenuButton} onClick={this.showDialog}>{i18n.t('自定义行列数')}</div>
            </div>
        );
    }

    private handleMouseOver = (index: number): (() => void) => () => {
        this.setState({ selectedIndex: index });
    };

    private handleClick = (): void => {
        if (this.state.selectedIndex < 0) return;

        const rowCount = Math.floor(this.state.selectedIndex / 10.0) + 1;
        const colCount = (this.state.selectedIndex % 10) + 1;
        this.props.hideMenu?.();
        this.prepareInsertData(rowCount, colCount);
    };

    private insertElement = (
        slideModel: ISlideModel, type: UIModelType,
        aExtraProp: ITableData, delElements: IDeleteElement[],
    ): void => {
        if (!this.getSelectionService()?.currentSlide) return;
        if (delElements.length > 0) {
            const aExtraProps: ITableData[] = [];
            aExtraProps.push(aExtraProp);
            const addNewEleInfos = aExtraProps.map((aExtraProp: any) => {
                const addNewEleInfo: any = {};
                addNewEleInfo.eleType = UIModelType.TABLE;
                addNewEleInfo.eleProps = aExtraProp;
                return addNewEleInfo;
            });

            slideModel.deletePlaceHolderAndAddNewElements(delElements, addNewEleInfos);
        } else {
            slideModel.addElement(type, aExtraProp);
        }
        // console.log(slideModel);
        const currentSlideChild = slideModel.children;
        const table = currentSlideChild.length ? currentSlideChild[currentSlideChild.length - 1] : undefined;
        (table as ITableModel)?.enterFirstCell();

        if (this.getSelectionService()) {
            this.getSelectionService().lastMouseDownRegion = RegionType.EDITOR;
            this.getSelectionService().selectedSlides.clear();
        }

        // 插入表格上报
        if (this.props.fromMenu) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_INSERT,
                action: TDWActionType.CLK_MENU_TABLE,
            });
        } else {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_INSERT,
                action: TDWActionType.CLK_TOOL_TABLE,
                ver10: TDWVer10Type.NEW_MENUBAR,
            });
        }
    };

    private getDefaultSize = (scaleRadio: number): { width: number; height: number } => {
        const element = Elements[UIModelType.TABLE];
        const height = element.defaultHeight * scaleRadio || element.props.style.height;
        const width = element.defaultWidth * scaleRadio || element.props.style.width;
        return {
            width,
            height,
        };
    };

    private getDefaultPosition = (placeHolderRect: any[], scaleRadio: number): { left: number; top: number } => {
        if (placeHolderRect.length === 1) {
            return this.getPlaceHolderPosition(placeHolderRect[0]);
        }
        const { slideWidth, slideHeight } = this.getUiDataService().presentation.props;
        const { width, height } = this.getDefaultSize(scaleRadio);
        let left = (slideWidth / 2) - (width / 2);
        let top = (slideHeight / 2) - (height / 2);
        const currentSlide = this.getSelectionService()?.currentSlide;
        const positions = currentSlide?.children.reduce((positionHashMap, child) => {
            const key = `${child.props.style.left}x${child.props.style.top}`;
            positionHashMap[key] = true; // eslint-disable-line no-param-reassign
            return positionHashMap;
        }, {});

        while (positions?.[`${left}x${top}`]) {
            left += 10;
            top += 10;
        }

        return {
            left,
            top,
        };
    };

    private getPlaceHolderPosition = (placeHolderRect: any): { left: number; top: number } => {
        const { left } = placeHolderRect;
        const { top } = placeHolderRect;

        return {
            left,
            top,
        };
    };

    // eslint-disable-next-line complexity
    private prepareInsertData = (rowCount: number, colCount: number): void => {
        const delElements: IDeleteElement[] = [];
        const placeHolderRect: any[] = [];
        const currentSlideIndex = this.getSelectionService()?.currentSlideIndex;
        const slides = this.getSelectionService()?.slides;
        const currentSlide = slides?.[currentSlideIndex];

        // 找不到currentSlide， 说明slide列表为空，刚不能插入元素， 有currentSlide时才插入及后续逻辑
        if (currentSlide) {
            const fistStep = this.insertToSelectedPlaceHolderIfExist(placeHolderRect, delElements);
            this.insertToExtraPlaceHolderIfExist(currentSlide, fistStep, placeHolderRect, delElements);
            const { slideWidth } = this.getUiDataService().presentation.props;

            // 根据画布尺寸与画布默认尺寸，算出缩放比来计算插入表格的大小，不要使用写死的尺寸
            const scaleRadio = slideWidth / defaultSlideWidth;
            const rect = this.getDefaultPosition(placeHolderRect, scaleRadio);
            // rect存在说明是点击占位符插入表格 不存在时是从toolbar或menu插入
            const width = (placeHolderRect.length === 1)
                ? placeHolderRect[0].width
                : defaultTableWidth * scaleRadio;
            const realWidth = Math.max(width / colCount, minColWidth) * colCount;
            const sdkData = TableDefault.makeDefaultSdkData(
                canvasToEmu(rect.left), canvasToEmu(rect.top),
                canvasToEmu(realWidth), canvasToEmu(minRowHeight * rowCount),
                rowCount, colCount,
            );
            if ((delElements.length === 1) && delElements[0]?.placeHolder) {
                delElements[0].placeHolder.type
                    ?                    sdkData.nvPr.ph = {
                        idx: delElements[0]?.sdkData?.props?.nvPr?.ph?.idx,
                        type: delElements[0]?.sdkData?.props?.nvPr?.ph?.type,
                    }
                    :                    sdkData.nvPr.ph = {
                        idx: delElements[0]?.sdkData?.props?.nvPr?.ph?.idx,
                    };
            }
            // 上报
            this.tdwReport(rowCount, colCount);

            this.insertElement(currentSlide, UIModelType.TABLE, sdkData, delElements);

            try {
                const toolbarService = InjectorService.get(ToolbarService);
                toolbarService.changeRibbonTab(FIXED_KEYS_DOUBLE.TOOLBAR_TABLE);
            } catch (e) {
                window.log.error('[Load wb toolbarService error]', e);
            }
        }
    };

    private tdwReport(rowCount: number, colCount: number): void {
        const reportInfo = {
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.TOOLBAR_INSERT_TAB,
            action: TDWActionType.SHAPES,
            eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_SHAPES,
        };
        if (this.props.wbPath?.includes(ActionType.SINGLE_TOOLBAR_MENU)) {
            tdw({
                ...reportInfo,
                ver3: 1,
                ver5: rowCount,
                ver6: colCount,
            });
        } else if (this.props.wbPath?.includes(FIXED_KEYS_DOUBLE.TOOLBAR_INSERT)) {
            tdw({
                ...reportInfo,
                ver3: 2,
                ver5: rowCount,
                ver6: colCount,
            });
        } else {
            const ver3 = this.getToolbarStateManager().getToolbarMode();
            // 上报
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_TOOLBAR_INSERT,
                action: TDWActionType.FORM,
                ver3,
                ver4: TDWVer4Type.TOOLBAR_NORMAL_DISPLAY,
                ver5: rowCount,
                ver6: colCount,
            });
        }
    }

    // 是否是可以插入表格的占位符
    private isPlaceHolderAcceptPic = (model): boolean => (model.isPlaceholder && !model.isCustomPlaceholder
                 && (model.placeHolder.type === PlaceHolderMode.TBL || typeof (model.placeHolder.type) === 'undefined'));

    private getAllSeletedModelsAcceptPic = (models) => {
        if (!models || typeof (models) === 'undefined' || models.length < 1) {
            return [];
        }
        // 过滤选中元素
        const selectedModels =  models.filter(model => this.isPlaceHolderAcceptPic(model));
        return selectedModels;
    };

    // firstStep: 如果有选中的表格占位符，优先插入
    private insertToSelectedPlaceHolderIfExist = (rect: any[], delElements: IDeleteElement[]): boolean => {
        const selectedUIModelArr = this.getSelectionService()?.selectedElements.selectedArray;
        const selectedPhAr = this.getAllSeletedModelsAcceptPic(selectedUIModelArr);
        if (!selectedPhAr || typeof (selectedPhAr) === 'undefined' || selectedPhAr.length < 1) {
            return false;
        }
        rect.push(selectedPhAr[0].props.style);
        delElements.push(selectedPhAr[0]);
        return true;
    };

    // secondStep: 如果有未选中的图片占位符，优先插入
    private insertToExtraPlaceHolderIfExist = (
        slideModel: ISlideModel, firstStep: boolean,
        rect: any[], delElements: IDeleteElement[],
    ): void => {
        if (firstStep) return;
        const phAr = slideModel.getElementsOfPlaceholderTypeInSlideExceptSlected(PlaceHolderMode.TBL);
        // 无可插入placeHolder
        if (typeof (phAr) === 'undefined' || phAr.length < 1) {
            return;
        }
        rect.push(phAr[0].props.style);
        delElements.push(phAr[0]);
    };

    private handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>): void => {
        this.setState({ selectedIndex: -1 });
    };

    private handleRowColCountChange = (rowCount: number, colCount: number): void => {
        this.customRowCount = rowCount;
        this.customColCount = colCount;
    };

    private dialogContent = (rowCount: number, colCount: number): JSX.Element => (
        <CreateTableDialog rowCount={rowCount} colCount={colCount}
            onRowColCountChange={this.handleRowColCountChange}
        ></CreateTableDialog>
    );

    private handleDialogConfirm = (): void => {
        if (this.customColCount > 20 || this.customRowCount > 20
            || this.customColCount < 1 || this.customRowCount < 1) {
            DUISnackbar.show({
                message: i18n.t('请输入有效的行列数'),
                type: 'error',
                autoClose: true,
            });
        } else {
            this.prepareInsertData(this.customRowCount, this.customColCount);
        }
    };

    private showDialog = (): void => {
        this.props.hideMenu?.();
        this.customRowCount = 2;
        this.customColCount = 5;
        Modal.confirm({
            title: i18n.t('自定义行列数'),
            content: this.dialogContent(this.customRowCount, this.customColCount),
            onOk: this.handleDialogConfirm,
        });
    };

    private getSelectionService() {
        return this.getAppService()?.viewableServiceLayer?.selectionService;
    }

    private getUiDataService() {
        return this.getAppService().getUiDataService();
    }

    private getToolbarStateManager = () => this.getAppService().viewableServiceLayer?.toolbarStateManager;

    private getAppService() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
